import { SERVICE_PROVIDERS } from '@/config/tenants/global';

export const subscriptionTierConfig = {
  [SERVICE_PROVIDERS.EM]: (subscriptionTier) => [
    ...(subscriptionTier === 'STANDARD' ? [{ label: 'Fleet Xpress', value: 'STANDARD' }] : []),
    ...(subscriptionTier === 'PRO' ? [{ label: 'Xtreme', value: 'PRO' }] : []),
    ...(subscriptionTier === 'TENNA' ? [{ label: 'Tenna', value: 'TENNA' }] : []),
  ],
  [SERVICE_PROVIDERS.TP]: (subscriptionTier) => [
    ...(subscriptionTier === 'LITE' ? [{ label: 'Professional', value: 'LITE' }] : []),
    ...(subscriptionTier === 'STANDARD' ? [{ label: 'Deluxe', value: 'STANDARD' }] : []),
    ...(subscriptionTier === 'PRO' ? [{ label: 'Fleet', value: 'PRO' }] : []),
    ...(subscriptionTier === 'TENNA' ? [{ label: 'Tenna', value: 'TENNA' }] : []),
  ],
  [SERVICE_PROVIDERS.GS]: (subscriptionTier) => [
    ...(subscriptionTier === 'LITE' ? [{ label: 'Prime8 ELD', value: 'LITE' }] : []),
    ...(subscriptionTier === 'STANDARD' ? [{ label: 'Fleet Xpress', value: 'STANDARD' }] : []),
    ...(subscriptionTier === 'PRO' ? [{ label: 'Xtreme', value: 'PRO' }] : []),
    ...(subscriptionTier === 'TENNA' ? [{ label: 'Tenna', value: 'TENNA' }] : []),
  ],
  default: (subscriptionTier) => [
    ...(subscriptionTier === 'LITE' ? [{ label: 'Prime8 ELD', value: 'LITE' }] : []),
    ...(subscriptionTier === 'STANDARD' ? [{ label: 'Fleet Xpress', value: 'STANDARD' }] : []),
    ...(subscriptionTier === 'PRO' ? [{ label: 'Xtreme', value: 'PRO' }] : []),
    ...(subscriptionTier === 'TENNA' ? [{ label: 'Tenna', value: 'TENNA' }] : []),
  ],
};
